import React from 'react';
import ChevronRightOutlinedIcon from "@material-ui/icons/ChevronRightOutlined";
import theme from './style';
import {useConfig} from "../../context/configContext";
import translate from "../../misc/applyTranslation";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import CheckIcon from "@material-ui/icons/Check";

const FilesTableRow = ({items, onBtnClick, modalOpen, copyList, copied}) => {
  const config = useConfig();
  const classes = theme(config);

  const getBadgeClass = category => {
    const badgeClassByCategory = {
      warning: classes.badgeWarning,
      error: classes.badgeError,
      info: classes.badgeInfo,
    };

    return badgeClassByCategory[category] || {};
  };

  const getTypeText = (category) => {
    const text = {
      warning: translate("files", "table_warning_badge_text"),
      error: translate("files", "table_error_badge_text"),
      info: translate("files", "table_info_badge_text"),
    };

    return text[category] || "";
  }

  const getQuantityClass = (category) => {
    const quantityClass = {
      error: classes.affected,
      warning: classes.affectedWarn,
      info: classes.affectedInfo,
    };

    return quantityClass[category] || {};
  }

  const getQuantityText = (event) => {
    const quantityText = {
      invoices: `${event.count} ${translate("files", "table_invoices_quantity_text")}`,
      customers: `${event.count} ${translate("files", "table_customers_quantity_text")}`,
    }

    return quantityText[event.entity] || `${event.count} ${translate("files", "table_invoices_quantity_text")}`;
  }

  const getExampleText = (event) => {
    if (event.entity === "customers") {
      return event.examples.map(example => example.identifier).join(", ")
    } else {
      const examples = event.examples.slice(0,3).map(example => "INV-" + example.identifier)

      return examples.join(", ") + (event.examples.length > 3 ? "..." : "")
    }
  }

  const getModalSubTitle = (event) => {
    if(event.entity === "customers") {
      return translate("files", "table_modal_customers_sub_title")
    } else {
      return translate("files", "table_modal_invoices_sub_title")
    }
  }

  return (
    <>
      {(items?.events?.groups || []).map((event, ind) => (
        <tr key={event.code + ind + event.category + event.entity}>
          <td>
            <div className={classes.eventName}>{translate("files", event.code)}</div>
            <div className={classes.eventDesc}>{translate("files", event.code + "_description")}</div>
          </td>
          <td><span className={`${classes.badge} ${getBadgeClass(event.category)}`}>{getTypeText(event.category)}</span>
          </td>
          <td><span className={getQuantityClass(event.category)}>{getQuantityText(event)}</span></td>
          <td className={classes.exampleText}>
            {getExampleText(event)}
          </td>
          <td>
            <button className={classes.showLink} onClick={() => onBtnClick(ind)}>
              {translate("files", "table_show_btn")}
              <ChevronRightOutlinedIcon/>
            </button>
          </td>
          {(modalOpen !== null && modalOpen === ind) &&
            <div className={classes.modalPanel} id={"modal-"+ind}>
              <div className={classes.modalHeader}>
                <h3 id={"modal-title"+ind}>{translate("files", event.code)}</h3>
                <button className={classes.modalClose} onClick={() => onBtnClick(null)}>
                  <CloseOutlinedIcon/>
                </button>
              </div>
              <p className={classes.modalSub} id={"modal-sub"+ind}>{getModalSubTitle(event)}</p>
              <button className={classes.copyListBtn} onClick={copyList}>
                {!copied ?
                  <>
                    <FileCopyOutlinedIcon/>
                    {translate("files", "table_modal_copy_list_btn")}
                  </>
                  :
                  <>
                    <CheckIcon/>
                    {translate("files", "table_modal_copied_list_btn")}
                  </>
                }

              </button>
              <div className={classes.modalList} id={"modal-list"+ind}>
                {event.examples?.map((item, index) => (
                  <div className={classes.modalListRow} key={index}>
                    <span>{event.entity === "invoices" ? `INV-${item.identifier}` : item.identifier}</span>
                    <span>{item.detail || ""}</span>
                  </div>
                ))}
              </div>
            {/*  <p className={classes.moreNote} id="modal-more">{MODAL_DATA[modalOpen].more}</p>*/}
            </div>
          }
        </tr>
      ))}
    </>
  )
}

export default FilesTableRow;